import script from "./brandTemp.vue?vue&type=script&setup=true&lang=js"
export * from "./brandTemp.vue?vue&type=script&setup=true&lang=js"

import "./brandTemp.vue?vue&type=style&index=0&id=de34448a&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de34448a"]])

export default __exports__